import styled from 'styled-components';
import { Flex, FlexProps } from '../Flex';

export const VirtualAdaptiveGridFlex = styled(Flex)
    .withConfig({ displayName: 'VirtualAdaptiveGrid' })
    .attrs<FlexProps>((props) => ({
        ...props,
        width: '100%',
        direction: 'row',
        position: 'relative',
        justifyContent: 'space-between',
    }))``;

export const VirtualAdaptiveGridColumn = styled(Flex)
    .withConfig({ displayName: 'VirtualAdaptiveGridColumn' })
    .attrs<FlexProps>((props) => ({
        ...props,
        height: '100%',
        position: 'relative',
    }))``;
